import validator from "validator";

export default function validate(values) {
  let errors = {};

  if (!values.activity_name || (values.activity_name && validator.isEmpty(values.activity_name, { ignore_whitespace: true }))) {
    errors.activity_name = "Required";
  }

  if (!values.method) {
    errors.method = "Required";
  }

  if (!values.category) {
    errors.category = "Required";
  }

  if (!values.actions || !values.actions.length) {
    // errors.actions = { _error: "At least one action must be created." }
  } else {
    let actionsArrayErrors = [];
    values.actions.forEach((action, index) => {
      let actionErrors = {};
      if (!action.action_name || (action.action_name && validator.isEmpty(action.action_name, { ignore_whitespace: true }))) {
        actionErrors.action_name = "Required";
        actionErrors.hasErrors = true;
        actionsArrayErrors[index] = actionErrors;
      }
      if (!action.before_likelihood) {
        actionErrors.before_likelihood = "Required";
        actionErrors.hasErrors = true;
        actionsArrayErrors[index] = actionErrors;
      }
      if (!action.before_consequence) {
        actionErrors.before_consequence = "Required";
        actionErrors.hasErrors = true;
        actionsArrayErrors[index] = actionErrors;
      }
      if (!action.control_measures || (action.control_measures && validator.isEmpty(action.control_measures, { ignore_whitespace: true }))) {
        actionErrors.control_measures = "Required";
        actionErrors.hasErrors = true;
        actionsArrayErrors[index] = actionErrors;
      }
      if (!action.after_likelihood) {
        actionErrors.after_likelihood = "Required";
        actionErrors.hasErrors = true;
        actionsArrayErrors[index] = actionErrors;
      }
      if (!action.after_consequence) {
        actionErrors.after_consequence = "Required";
        actionErrors.hasErrors = true;
        actionsArrayErrors[index] = actionErrors;
      }

      if (!action.hazards || !action.hazards.length) {
        
      } else {
        let hazardArrayErrors = [];
        action.hazards.forEach((hazard, hIndex) => {
          let hazardErrors = {};
          if (!hazard.hazard_name || (hazard.hazard_name && validator.isEmpty(hazard.hazard_name, { ignore_whitespace: true }))) {
            hazardErrors.hazard_name = "Required";
            hazardArrayErrors[hIndex] = hazardErrors;
          }
          if (!hazard.consequences || !hazard.consequences.length) {
            // hazardErrors.consequences = { _error: "At least one consequence is required." }
            hazardArrayErrors[hIndex] = hazardErrors;
          } else {
            let consequencesArrayErrors = [];
            hazard.consequences.forEach((consequence, cIndex) => {
              let consequenceErrors = {};
              if (!consequence.consequence_name || (consequence.consequence_name && validator.isEmpty(consequence.consequence_name, { ignore_whitespace: true }))) {
                consequenceErrors.consequence_name = "Required";
                consequencesArrayErrors[cIndex] = consequenceErrors;
              }
            })

            if (consequencesArrayErrors.length) {
              hazardErrors.consequences = consequencesArrayErrors;
              hazardArrayErrors[hIndex] = hazardErrors;
            }
          }
        });

        if (hazardArrayErrors.length) {
          actionErrors.hazards = hazardArrayErrors;
          actionErrors.hasErrors = true;
          actionsArrayErrors[index] = actionErrors;
        }
      }
      if (actionsArrayErrors.length) {
        errors.actions = actionsArrayErrors;
      }
    })
  }

  return errors;
}